import { createSlice } from "@reduxjs/toolkit";
import { FULLFILLED } from "@root/constants";
import { AUTH_LOGIN, AUTH_LOGOUT } from "@root/store/action-types";
import {
  USER_PROFILE,
  UPDATE_TOUR_COMPLETION,
} from "@root/store/action-types/userProfile";
import { ADMIN_LOGIN_ACTION } from "@root/store/action-types/admin/auth";

const INITIAL_STATE: IAuthEntities = {
  data: null,
  givenEmailForPasswordRecovery: {
    email: "test@gmail.com",
  },
  avatar: "",
  profile: {},
};

export const authEntitySlice = createSlice({
  name: "auth",
  initialState: INITIAL_STATE,
  reducers: {
    resetAuthData: (state) => {
      state.data = null;
    },
    setAuthData: (state, action) => {
      state.data = action.payload;
    },
    updatePasswordRecoverEmail: (state, action) => {
      state.givenEmailForPasswordRecovery = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(`${AUTH_LOGIN}${FULLFILLED}`, (state, action: any) => {
      const { token, ...rest } = action.payload;
      // If response has a nested 'user' object, merge it with other fields
      // Otherwise, store all fields directly to ensure all data is preserved
      if (rest?.user && typeof rest.user === "object") {
        // Merge user properties with other top-level properties, prioritizing user data
        const { user, ...otherFields } = rest;
        state.data = { ...user, ...otherFields };
      } else {
        // No nested user object, store everything as-is
        state.data = rest;
      }
    });
    builder.addCase(`${AUTH_LOGOUT}${FULLFILLED}`, (state) => {
      state.data = null;
    });
    builder.addCase(`${ADMIN_LOGIN_ACTION}${FULLFILLED}`, (state, action: any) => {
      const payload = action.payload;
      // Handle admin login response structure
      // Admin login returns { token, user, ... } structure
      if (payload?.user && typeof payload.user === "object") {
        // Merge user properties with other top-level properties
        const { user, token, ...otherFields } = payload;
        state.data = { ...user, ...otherFields };
      } else {
        // No nested user object, store everything as-is
        const { token, ...rest } = payload;
        state.data = rest;
      }
    });
    builder.addCase(`${USER_PROFILE}${FULLFILLED}`, (state, action: any) => {
      // Merge the updated user data with existing data to preserve all fields
      // This ensures no data is lost when updating user profile
      if (action?.payload) {
        state.data = {
          ...state.data,
          ...action.payload,
        };
      }
    });
    builder.addCase(
      `${UPDATE_TOUR_COMPLETION}${FULLFILLED}`,
      (state, action: any) => {
        // Merge the updated user data with existing data to preserve all fields
        // This ensures tour completion flags are updated in Redux state
        if (action?.payload) {
          state.data = {
            ...state.data,
            ...action.payload,
          };
        }
      }
    );
    // builder.addCase(`${GET_PROFILE}${FULLFILLED}`, (state, action: any) => {
    //   state.profile = action?.payload;
    // });
  },
});

export const { resetAuthData, setAuthData, updatePasswordRecoverEmail } =
  authEntitySlice.actions;

export const authEntityReducer = authEntitySlice.reducer;
